import { ActionsUnion, createAction } from '@housinganywhere/safe-redux';
import reportError from 'ha/helpers/bugsnag/reportError';
import { GlobalState } from 'ha/types/store';
import { HermesLoadOptions } from 'ha/services/hermes';
import { COUNTRY, APOLLO_COUNTRY } from 'ha/constants/pageNames';
import HttpStatus from 'ha/constants/HttpStatus';

import { Thunk } from '../../myredux/types';
import { HermesResponse } from './types';
import { getInfo, getData } from './selectors';

export enum ActionTypes {
  START = '[hermes] LOAD_START',
  DONE = '[hermes] LOAD_DONE',
  NOT_FOUND = '[hermes] NOT_FOUND',
  FAIL = '[hermes] LOAD_FAIL',
}

export const Actions = {
  start: () => createAction(ActionTypes.START),
  done: (data: HermesResponse) => createAction(ActionTypes.DONE, data),
  notFound: () => createAction(ActionTypes.NOT_FOUND),
  fail: () => createAction(ActionTypes.FAIL),
};

export type ActionsUnionType = ActionsUnion<typeof Actions>;

export const loadHermesData =
  (
    pathname: string,
    options: HermesLoadOptions = { includeData: true },
  ): Thunk<GlobalState> =>
  (dispatch, getState, { hermes }) => {
    const state = getState();
    const info = getInfo(state);

    const infoIsLoaded = info && info.path === pathname;
    const dataIsLoaded = options.includeData ? Boolean(getData(state)) : true;

    if (infoIsLoaded && dataIsLoaded) {
      return Promise.resolve();
    }

    dispatch(Actions.start());

    return hermes
      .load(pathname, options)
      .then(data => {
        // TODO: remove after hermes update
        if (data.info.type === APOLLO_COUNTRY) {
          // eslint-disable-next-line no-param-reassign
          data.info.type = COUNTRY;
        }

        dispatch(Actions.done(data));
      })
      .catch(error => {
        // Both these status codes are expected from Hermes
        // 404 means Contentful does not have data for the City and Country
        // 304 means the data has not changed since the last call, but Fetch API
        // treats it as a NOT OK response, therefore it's an error
        if (error?.code === HttpStatus.NOT_MODIFIED) {
          return;
        }

        if (error?.code === HttpStatus.NOT_FOUND) {
          dispatch(Actions.notFound());
          return;
        }

        dispatch(Actions.fail());
        reportError('loadHermesData failed', { metaData: error });
      });
  };
